import React, { useEffect } from "react";
import CrearEmpresa from "../components/Empresas/CrearEmpresa";
import i18n from "../i18n/config";

const AddCompanyPage = () => {
  useEffect(() => {
    document.title = `${window._env_.REACT_APP_EMPRESA_NAME} - ${i18n.t("crear.pageTitle", { ns: "empresas" })}`;
  }, []);

  return <CrearEmpresa />;
};

export default AddCompanyPage;
